export default __webpack_public_path__ + "static/media/happy.6b8621a8.jpg";